import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicAcademicYearFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M15.53 5.25L8.57 3.11a2 2 0 00-1.17 0L.44 5.25a.59.59 0 000 1.14l1.21.37c-.26.33-.43.73-.44 1.17a.79.79 0 00-.41.69c0 .27.14.5.34.64l-.63 2.86a.4.4 0 00.39.49h1.4a.4.4 0 00.39-.49l-.64-2.86a.8.8 0 00.35-.64.79.79 0 00-.4-.67c.02-.38.22-.71.52-.92l4.88 1.5a2 2 0 001.17 0l6.96-2.14a.59.59 0 000-1.14zM8.81 9.3a2.8 2.8 0 01-1.64 0L3.55 8.18l-.35 2.83c0 .88 2.14 1.6 4.79 1.6 2.64 0 4.79-.72 4.79-1.6l-.35-2.83L8.8 9.29z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicAcademicYearFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicAcademicYearFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicAcademicYearFilled svgRef={ref} {...props} />
));
export default ForwardRef;
